import { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import MessageAlert from 'app/components/MessageAlert'

export const useError = () => {
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()

  const errors = useCallback(
    (text) => {
      const generalError = formatMessage({ id: 'error.InternalServerError' })
      return dispatch(
        MessageAlert.showError({
          message: text ?? generalError,
        }),
      )
    },
    [dispatch, formatMessage],
  )

  return { errors }
}
